import { Component, OnInit, Input } from '@angular/core';

import { ControlSpecification } from '../../types/specification.types';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'dy-tool-box-group',
  templateUrl: './tool-box-group.component.html',
  styleUrls: ['./tool-box-group.component.css']
})
export class ToolBoxGroupComponent implements OnInit {
  _controlSpecifications: ControlSpecification[];

  @Input() groupName: string;

  @Input()
  get controlSpecifications(): Array<ControlSpecification> {
    return this._controlSpecifications;
  }

  set controlSpecifications(value: Array<ControlSpecification>) {
    this._controlSpecifications = value;
  }

  constructor() {}

  ngOnInit() {}
}
